<template>
  <h1>Настройки</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>